import React, { useState, useEffect } from "react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";

import "./TeacherResume.css";
// import QualificationForm from "./QualicationForm";
import QualificationForm from "./QualicationForm.redux";
import { connect } from "react-redux";
import {
  deleteQualification,
  deleteProfessionalDevelopment,
  deleteProfessionalExperience,
  deleteRefereeCheck,
  deleteNonTeachingExperience,
  deleteVetTrainingQualification,
  deleteVetIndustryQualification,
  deleteVetProfessionalDevelopment,
  deleteVetTrainingExperience,
  deleteVetIndustryExperience,
  deleteVetTrainerMatrix,
} from "../../redux/homePage/homePage.actions";
import useModal from "./useModal";
import VocationalQualification from "./Vocational/VocationalQualification"
import VocationalExperience from "./Vocational/VocationalExperience"
import VocationalProfDevelopment from "./Vocational/VocationalProfDevelopment"
import VocationalTrainerMatrix from "./Vocational/VocationalTrainerMatrix"
import {displayPoliceCheckWwCC} from "../Container/HomeContainer2";
import TeacherHours from "../../Components/CountDown/TeacherHours";
import { teacherLevel } from "../../Helper";
import ImportGoogleDriveFile from "../../Components/GoogleDrive/ImportFile";
import DragDropFile from "../../Components/DragUpload/DragDropFile";
import QualificationModal from "./QualificationModal";
import { API } from "../../API";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { notify } from "react-notify-toast";

const VocationalResumeContents = (props) => {
  const { user, isViewAsTeacher } = props;
  const {
    deleteQualification,
    deleteProfessionalDevelopment,
    deleteProfessionalExperience,
    deleteRefereeCheck,
    deleteNonTeachingExperience,
    deleteVetTrainingQualification,
    deleteVetIndustryQualification,
    deleteVetProfessionalDevelopment,
    deleteVetTrainingExperience,
    deleteVetIndustryExperience,
    deleteVetTrainerMatrix,
  } = props;

  const { isShowing, toggle } = useModal();
  const [content, setContent] = useState();
  const [qTarget, setQTarget] = useState("");
  const [qType, setQType] = useState("");
  const [isPopup, togglePopup] = useState(false);
  const [isCreate, toggleCreate] = useState(true);
  const [qualificationID, setQualificationID] = useState("");
  const [formType, setFormType] = useState("");
  const [isDeleteQuaPopup, toggleDeleteQuaPopup] = useState(false);

  const [certificateFile, setCertificateFile] = useState(null)
  const [transcriptFile, setTranscriptFile] = useState(null)
  const [evidenceEnrolmentFile, setEvidenceEnrolmentFile] = useState(null)
  const [isQualPopup, toggleQualPopup] = useState(false);
  const [isUploadDrive, setIsUploadDrive] = useState(false)
  const [fileFromDrive, setFileFromDrive] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const quali_ref = React.createRef();
  const exp_ref = React.createRef();
  const referee_ref = React.createRef();

  const handleDeleteVetResume = () => {
    // console.log(qTarget, qType)
    if (qType != null) {
      if (qType === 'qualification') {
        deleteQualification(qTarget._id)
      } else if (qType === 'prof_dev') {
        deleteProfessionalDevelopment(qTarget._id)
      } else if (qType === 'tech_exp') {
        deleteProfessionalExperience(qTarget._id)
      } else if (qType === 'other_pro_exp') {
        deleteNonTeachingExperience(qTarget._id)
      } else if (qType === 'pro_refree') {
        deleteRefereeCheck(qTarget._id)
      } else if (qType === 'VTQ') {
        deleteVetTrainingQualification(qTarget._id)
      } else if (qType === 'VIQ') {
        deleteVetIndustryQualification(qTarget._id)
      } else if (qType === 'VPD') {
        deleteVetProfessionalDevelopment(qTarget._id)
      } else if (qType === 'VTE') {
        deleteVetTrainingExperience(qTarget._id)
      } else if (qType === 'VIE') {
        deleteVetIndustryExperience(qTarget._id)
      } else if (qType === 'VTM') {
        deleteVetTrainerMatrix(qTarget._id)
      }
    }
    toggle()
  }

  const showAddTrainingQual = () => {
    setContent("");
    setFormType("VTQ");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const showEditTrainingQual = (q) => {
    setContent(q);
    setFormType("VTQ");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddIndQualification = () => {
    setContent("");
    setFormType("VIQ");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const showEditIndQualification = (q) => {
    setContent(q);
    setFormType("VIQ");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddProfDev = () => {
    setContent("");
    setFormType("VPD");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const showEditProfDev = (q) => {
    setContent(q);
    setFormType("VPD");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddTrainingExp = () => {
    setContent("");
    setFormType("VTE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const showEditTrainingExp = (q) => {
    setContent(q);
    setFormType("VTE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddIndustryExp = () => {
    setContent("");
    setFormType("VIE");
    toggleCreate(true);
    togglePopup(true);
  };

  const showEditIndustryExp = (q) => {
    setContent(q);
    setFormType("VIE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddMatrix = () => {
    setContent("");
    setFormType("VTM");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  }

  const showAddReferee = (q) => {
    if (q) {
      setContent(q);
    } else {
      setContent("");
    }
    setFormType("referee");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  let newUser;
  if (isDeleteQuaPopup) {
    // ======= Update user  =======
    newUser = Object.assign({}, user);
    const arr = newUser.qualifications.filter((q) => q._id !== qualificationID);
    newUser.qualifications = arr;
  }

  const showVerificationStatus = (qual) => {
    const qualsToVerify = [
      "Bachelor of",
      "Master of/in",
      "PhD in",
      "Graduate Diploma of/in",
      "Graduate Certificate in",
    ];
    return qualsToVerify.includes(qual);
  };


  const resetAllFilesUpload = () => {
    setCertificateFile(null)
    setTranscriptFile(null)
    setEvidenceEnrolmentFile(null)
  }

  const handleChangeFileDragDrop = async (fileUpload, fileType, qualificationType) => {
    switch (fileType) {
      case "certificate":
        setCertificateFile(fileUpload)

        let qualificationContent = {}
        const formData = new FormData();
        formData.append("file", fileUpload);

        try {
          setIsLoading(true)

          if (fileUpload?.type === 'application/pdf') {
            const res = await API.readTextFromFileDragDrop(formData);
            const text = res.data?.data;
      
            if (text) {
              const response = await API.readQualificationContentFromText({ data: text });
              qualificationContent = response.data?.data;
            }
          }

          setContent({
            ...content,
            certificate_filename: fileUpload.name,
            institution_name: qualificationContent?.institute || '',
            award_name: qualificationContent?.award || '',
            // graduation_date: qualificationContent?.date
          });

          toggleQualPopup(true);
          setIsLoading(false)
        } catch (error) {
          setContent({
            ...content,
            certificate_filename: fileUpload.name,
          });

          toggleQualPopup(true);
          setIsLoading(false)

          console.log('Error:', error);
        }
        break;
      case "transcript":
        setTranscriptFile(fileUpload)
        setContent({
          ...content,
          certificate_filename: fileUpload.name,
        });
        break;
      case "evidence-enrolment":
        setEvidenceEnrolmentFile(fileUpload)
        setContent({
          ...content,
          enrolment_filename: fileUpload.name,
        });
        break;
    }
  }

  const handleSelectFile = async (fileUpload, qualificationType) => {
    // setFile(fileUpload?.fileId)

    let qualificationContent = {}

    try {
      setIsLoading(true)

      if (fileUpload?.mimeType === 'application/pdf') {
        const res = await API.readTextFromGoogleDriveFile(fileUpload);
        const text = res.data?.data;
      
        if (text) {
          const response = await API.readQualificationContentFromText({ data: text });
          qualificationContent = response.data?.data;
        } 
      }

      setContent({
        certificate_filename: fileUpload.fileName,
        institution_name: qualificationContent?.institute || '',
        award_name: qualificationContent?.award || '',
        // graduation_date: qualificationContent?.date
      });

      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      
      if (qualificationType === "vet-training-assessment") {
        setFormType("VTQ");
      } else if (qualificationType === "vet-industry-qualification") {
        setFormType("VIQ")
      }
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(false)
    } catch (error) {
      setContent({
        certificate_filename: fileUpload.name,
      });

      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      
      if (qualificationType === "vet-training-assessment") {
        setFormType("VTQ");
      } else if (qualificationType === "vet-industry-qualification") {
        setFormType("VIQ")
      }
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(false)

      console.log('Error:', error);
    }
  }

  useEffect(() => {
    var focus_ref = null
    switch (window.location.hash) {
      case "#updateQualification":
        focus_ref = quali_ref
        break;
      case "#updateExp":
        focus_ref = exp_ref
        break;
      case "#updateReferee":
        focus_ref = referee_ref
        break;
      default:
        break;
    }
    if (focus_ref) {
      console.log('scroll')
      focus_ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [])
  return (
    <div className="teacher-profile-wrapper mt-3">
      {isPopup && (
        <QualificationForm
          user={user}
          showPopup={togglePopup}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          toggleLoading={(status) => setIsLoading(status)}
          handleChangeFileDragDrop={handleChangeFileDragDrop}
          certificateFile={certificateFile}
          transcriptFile={transcriptFile}
          evidenceEnrolmentFile={evidenceEnrolmentFile}
          isEdit={isEdit}
          resetAllFilesUpload={resetAllFilesUpload}
        />
      )}

      {/* {isQualPopup && (
        <QualificationModal
          user={user}
          showPopup={toggleQualPopup}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          file={file}
          resetFile={() => setFile(null)}
          isUploadDrive={isUploadDrive}
          fileFromDrive={fileFromDrive}
          toggleLoading={(status) => setIsLoading(status)}
        />
      )} */}
      <div className="container p-0">
        <div className="row">
          <div className="col-lg-6">
            <span ref={quali_ref}></span>
            <ProfileBox
              header="Training & Assessment"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddTrainingQual}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {/* { isViewAsTeacher &&
                  <ImportGoogleDriveFile
                    handleSelectFile={handleSelectFile}
                    qualificationType="vet-training-assessment"
                  />
              } */}


              {!!user.vet_training_quals.length &&
                <VocationalQualification
                  isViewAsTeacher={isViewAsTeacher}
                  qualType="VTQ"
                  qualifications={user.vet_training_quals}
                  showEditQual={showEditTrainingQual}
                  setQTarget={setQTarget}
                  setQType={setQType}
                  toogleShowConfirmModal={toggle}
                />
              }
            </ProfileBox>

            <ProfileBox
              header="Industry Qualifications"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddIndQualification}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {/* { isViewAsTeacher &&
                  <ImportGoogleDriveFile
                    handleSelectFile={handleSelectFile}
                    qualificationType="vet-industry-qualification"
                  />
              } */}

              {!!user.vet_industry_quals.length &&
                <VocationalQualification
                  isViewAsTeacher={isViewAsTeacher}
                  qualType="VIQ"
                  qualifications={user.vet_industry_quals}
                  showEditQual={showEditIndQualification}
                  setQTarget={setQTarget}
                  setQType={setQType}
                  toogleShowConfirmModal={toggle}
                />
              }
            </ProfileBox>

            {/* professional development */}
            <ProfileBox
              header="Professional Development"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddProfDev}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {!!user.vet_pd.length &&
                <VocationalProfDevelopment
                  isViewAsTeacher={isViewAsTeacher}
                  developments={user.vet_pd}
                  showEditProfDev={showEditProfDev}
                  setQTarget={setQTarget}
                  setQType={setQType}
                  toogleShowConfirmModal={toggle}
                />
              }
            </ProfileBox>
          </div>

          <div className="col-lg-6">
            <div className="experience">
              <TeacherHours user={user} />
              {
                user?.vet_level === teacherLevel.GOLD && 
                <>
                <img
                className="vet-teacher-level-badge"
                src={require("../../assets/img/gold-icon.png")}
                alt="senior badge"/>
                </>
              }
              {
                user?.vet_level === teacherLevel.SILVER && 
                <>
                <img
                className="vet-teacher-level-badge"
                src={require("../../assets/img/sliver-icon.png")}
                alt="senior badge"/>
                </>
              }
              {
                user?.vet_level === teacherLevel.BRONZE && 
                <>
                <img
                className="vet-teacher-level-badge"
                src={require("../../assets/img/bronze-icon.png")}
                alt="senior badge"/>
                </>
              }
            </div>
            <div>
              {/*  Teaching Experience*/}
              <span ref={exp_ref}></span>
              <ProfileBox
                header="Teaching Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddTrainingExp}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {!!user.vet_training_exp.length &&
                  <VocationalExperience
                    isViewAsTeacher={isViewAsTeacher}
                    expType="VTE"
                    experiences={user.vet_training_exp}
                    showEditExp={showEditTrainingExp}
                    setQTarget={setQTarget}
                    setQType={setQType}
                    toogleShowConfirmModal={toggle}
                  />
                }
              </ProfileBox>

              <ProfileBox
                header="Industry Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddIndustryExp}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {!!user.vet_industry_exp.length &&
                  <VocationalExperience
                    isViewAsTeacher={isViewAsTeacher}
                    expType="VIE"
                    experiences={user.vet_industry_exp}
                    showEditExp={showEditIndustryExp}
                    setQTarget={setQTarget}
                    setQType={setQType}
                    toogleShowConfirmModal={toggle}
                  />
                }
              </ProfileBox>
            </div>

            <div>
              <ProfileBox
                header="Trainer Matrix"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddMatrix}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {!!user.vet_matrix.length &&
                  <VocationalTrainerMatrix
                    isViewAsTeacher={isViewAsTeacher}
                    matrices={user.vet_matrix}
                    setQTarget={setQTarget}
                    setQType={setQType}
                    toogleShowConfirmModal={toggle}
                  />
                }
              </ProfileBox>
            </div>

            {/* PROFESSIONAL REFEREE */}
            {props.isViewAsTeacher && (
                <>
                  <span ref={referee_ref}></span>
                  <ProfileBox
                      header="Professional Referee"
                      footer={
                        isViewAsTeacher && (!user.referees || user.referees.length < 2) && (
                            <span onClick={() => showAddReferee()}>
                          <Icon
                              name="add"
                              circular
                              inverted
                              color="#3bb4d8"
                              className="qualification-container-update-icon"
                          >
                            {" "}
                          </Icon>
                              {"  "}Add New
                        </span>
                        )
                      }
                  >
                    {user.referees.length > 0
                        ?
                        <ul className="container p-0">
                          {user.referees.map((q, index, array) => {
                            return (
                                <li key={q._id} className="p-0">
                                  <div className="row">
                                    <div className="col-8">
                                      <p className="mt-0 mb-2 profile-qualification-title text-left">
                                        {q.organisation}
                                      </p>
                                      <p className="mt-0 mb-2 profile-qualification-place text-left">
                                        {q.referee_first_name +
                                        " " +
                                        q.referee_last_name +
                                        "  (" +
                                        q.referee_position_title +
                                        ")"}
                                      </p>
                                      <p className="profile-qualification-place text-left">
                                        {q.referee_email}
                                      </p>
                                    </div>

                                    {isViewAsTeacher ? (
                                        <div className="col-4">
                                          <p className="mb-0 profile-qualification-title text-right mt-2">
                                            <Icon
                                                name="pencil"
                                                circular
                                                inverted
                                                color="#3bb4d8"
                                                onClick={() => showAddReferee(q)}
                                                className="qualification-container-update-icon"
                                            >
                                              {" "}
                                            </Icon>
                                            <Icon
                                                name="trash"
                                                circular
                                                inverted
                                                color="grey"
                                                onClick={() => {
                                                  setQTarget(q)
                                                  setQType('pro_refree')
                                                  toggle(true)
                                                }}
                                                className="qualification-container-update-icon"
                                            >
                                              {" "}
                                            </Icon>
                                          </p>
                                        </div>
                                    ) : null}
                                    <hr className="qualification-line-1"></hr>
                                  </div>
                                </li>
                            );
                          })
                          }
                        </ul>
                        : null}
                  </ProfileBox>
                </>
            )}

            {/* Police & Children Checks */}
            <ProfileBox header='Police & USI Checks'>
              <div>{displayPoliceCheckWwCC}</div>
            </ProfileBox>
          </div>
        </div>
      </div>

      <Modal
        className="confirm-delete"
        header="Do you wish to delete?"
        show={isShowing}
        onClose={toggle}
      >
        <div className="row m-0">
          <div className="col-md-6">
            <CancelButton
              type="button"
              onClick={toggle}
            >
              Cancel
              </CancelButton>
          </div>
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton
              type="button"
              onClick={handleDeleteVetResume}
              id={'q._id'}
            >
              Yes and Proceed
              </ConfirmButton>
          </div>
        </div>
      </Modal>

      <Backdrop
        sx={{ color: '#fff', zIndex: 1200 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  deleteQualification: (user) => dispatch(deleteQualification(user)),
  deleteProfessionalDevelopment: (user) =>
    dispatch(deleteProfessionalDevelopment(user)),
  deleteProfessionalExperience: (user) =>
    dispatch(deleteProfessionalExperience(user)),
  deleteRefereeCheck: (user) => dispatch(deleteRefereeCheck(user)),
  deleteNonTeachingExperience: (user) =>
    dispatch(deleteNonTeachingExperience(user)),
  deleteVetTrainingQualification: (user) =>
    dispatch(deleteVetTrainingQualification(user)),
  deleteVetIndustryQualification: (user) =>
    dispatch(deleteVetIndustryQualification(user)),
  deleteVetProfessionalDevelopment: (user) =>
    dispatch(deleteVetProfessionalDevelopment(user)),
  deleteVetTrainingExperience: (user) =>
    dispatch(deleteVetTrainingExperience(user)),
  deleteVetIndustryExperience: (user) =>
    dispatch(deleteVetIndustryExperience(user)),
  deleteVetTrainerMatrix: (user) =>
    dispatch(deleteVetTrainerMatrix(user)),
});

export default connect(null, mapDispatchToProps)(VocationalResumeContents);
